// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Nt_u5"};